import React from "react";
import { useEffect, useState } from "react";
import { MathJax} from "better-react-mathjax";

// import ExercisePage from "../ExercisePage";

import style from "./ExercisePanel.css";


const ExercisePanel = ({sectionName, exercise_id, exercise_content, exercise_difficulty}) => {
    
    const [difficultyWithEmojis, setDifficultyWithEmojis] = useState("🌶️");


    const setExerciseDifficulty = () => {
        var difficulty_with_emojis = "";
        for(var i=0; i < exercise_difficulty; i++) {
            difficulty_with_emojis += "🌶️";
        }
        setDifficultyWithEmojis(difficulty_with_emojis);
    };

    useEffect(() => {
        setExerciseDifficulty();
      }, []);

    return (
        <div className="exercise-panel" id={sectionName + '-' + exercise_id}>
            <div className="exercise-panel-title">
                <div className="exercise-id"><h5>Exercise {exercise_id}</h5></div>
                <div className="exercise-difficulty"><h5>{difficultyWithEmojis}</h5></div>
            </div>
            <div className="execise-panel-content">
                    <MathJax dynamic>
                        <p style={{ textAlign: "left", whiteSpace: "pre-line"}} id='formulas'>{exercise_content}</p>
                    </MathJax>{" "}
            </div>
        </div>
    );
}

export default ExercisePanel;